<h3 mat-dialog-title>{{ data.title }}</h3>
<mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-sm-end pe-2 pe-sm-4 border-top gap-2">
  <wfs-form-button
    (buttonClicked)="triggerEvent(true)"
    [label]="data.confirmText"
    [buttonStyle]="'primary'" />
  <wfs-form-button
    (buttonClicked)="triggerEvent(false)"
    [label]="data.denyText"
    [buttonStyle]="'warning'" />
</mat-dialog-actions>
